import React, { useState } from 'react';
import { Segmented, Typography } from 'antd';
import { Webhook } from 'lucide-react';
import { WebhookEventPayload } from './data/webhookEvents';
import { WebhookEventCard } from './WebhookEventCard';
import { WebhookType } from '@/types/TReseller';

const { Title, Paragraph } = Typography;

interface WebhookPayloadPreviewerProps {
	events: WebhookEventPayload[];
}

export const WebhookPayloadPreviewer: React.FC<WebhookPayloadPreviewerProps> = ({ events }) => {
	const [payloadType, setPayloadType] = useState<WebhookType>(WebhookType.API);
	return (
		<div className="max-w-4xl mx-auto">
			<div className="flex items-center mb-2 gap-3">
				<Webhook size={24} className="-mt-2" />
				<Title level={2}>Webhook Payload Reference</Title>
			</div>
			<Paragraph style={{ color: '#94A3B8', fontSize: '16px' }}>
				Below you'll find a reference for all the webhook event payloads our system will send. Each
				event shows the exact JSON structure that will be sent to your webhook URL.
			</Paragraph>

			<Segmented
				options={[
					{ label: 'API Payload', value: WebhookType.API },
					{ label: 'Slack Payload', value: WebhookType.SLACK },
				]}
				value={payloadType}
				onChange={(val) => setPayloadType(val as WebhookType)}
				className="mb-6"
				size="large"
				block
			/>

			<div className="space-y-2">
				{events.map((event) => (
					<WebhookEventCard key={event.id} event={event} payloadType={payloadType} />
				))}
			</div>
		</div>
	);
};
